// JS
import React from 'react';
import { randomId } from '../shared/utils';

// COMPONENT
const Button = ({
  gaTitle,
  gaName,
  gaBlockId,
  gaAriaLabel,
  gaDataType,
  gaProdSku,
  gaList,
  gaImage,
  gaBrand,
  gaPrice,
  gaCategory,
  gaPromoPrice,
  gaQuantity,
  gaVariant,
  gaCurrency,
  gaSizeSelected,
  gaSale,
  gaDisabled,
  buttonColour = 'white',
  buttonGroup = false,
  buttonLink,
  buttonLinkContent,
  buttonAdditionalClasses,
  buttonSlotNumber = 1,
  setClick = true,
  clickProperties
}) => {
  const uniqueId = randomId();
  const gaTracking = gaTitle && gaName && gaBlockId;
  const buttonColours = {
    white: `block w-full h-auto py-8 px-12 text-md text-black text-center font-bold uppercase border border-solid border-gray-300 bg-transparent transition ease-in-out duration-400 ${
      buttonGroup
        ? 'group-hover:!text-black group-hover:!bg-white'
        : 'hover:!text-black hover:!bg-white'
    } tracking-widest`,
    black: `block w-full h-auto py-8 px-12 text-md text-white text-center font-bold uppercase border border-solid border-black bg-black transition ease-in-out duration-400 tracking-widest`
  };

  return (
    <div className="flex justify-center">
      <button
        aria-label={gaTracking && gaAriaLabel}
        onClick={
          setClick
            ? clickProperties
            : (e) => {
                e.preventDefault();
                if (e.metaKey || e.ctrlKey) {
                  window.open(buttonLink, '_blank');
                } else {
                  window.open(buttonLink, '_self');
                }
              }
        }
        id={'button-id-' + uniqueId}
        className={
          buttonColours[buttonColour] +
          (buttonAdditionalClasses?.classes
            ? ' ' + buttonAdditionalClasses.classes
            : '')
        }
        data-name={gaTracking && gaTitle}
        data-creative={gaTracking && gaName}
        data-id={gaTracking && gaBlockId}
        data-position={gaTracking && 'button-slot-' + buttonSlotNumber}
        data-type={gaTracking && gaDataType}
        data-sku={gaTracking && gaProdSku}
        data-list={gaTracking && gaList}
        data-image={gaTracking && gaImage}
        data-brand={gaTracking && gaBrand}
        data-category={gaTracking && gaCategory}
        data-price={gaTracking && gaPrice}
        data-promotion-price={gaTracking && gaPromoPrice}
        data-quantity={gaTracking && gaQuantity}
        data-variant={gaTracking && gaVariant}
        data-currency={gaTracking && gaCurrency}
        data-size-selected={gaTracking && gaSizeSelected}
        data-onsale={gaTracking && gaSale}
        disabled={gaTracking && gaDisabled}
      >
        {buttonLinkContent}
      </button>
    </div>
  );
};

export default Button;
